module.exports = __webpack_public_path__ + "static/media/backsplash4.b3d01fc5.jpg";